import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/axios";
import { useToast } from '@/hooks/use-toast';

type UploadFields = {
  url: string;
  cdn_url: string;
};

const upload = async (file: File, key: string): Promise<string> => {
  const { data: fields } = await axiosInstance.post<UploadFields>('/api/abo/upload', { key, contentType: file.type });
  try {
    await axiosInstance.put(fields.url, file, {
      headers: {
        "Content-Type": file.type,
      },
    });
  } catch (err) {
    console.error(err);
    throw new Error("Error dans l'upload");
  }

  return fields.cdn_url;
};

type UploadArgs = {
  file: File;
  key: string;
};

export function useUpload(): UseMutationResult<string, unknown, UploadArgs> {
  const { toast } = useToast();

  return useMutation<string, unknown, UploadArgs>({
    mutationFn: ({ file, key }) => upload(file, key),
    onSuccess: () => {
      toast({
        title: "Le fichier est chargé",
        variant: "default"
      });
    },
    onError: (e) => {
      console.error(e)
      toast({
        title: "Une erreur s'est produite lors du chargement du fichier",
        variant: "destructive",
      });
    },
  });
}
